<template>
  <div
    class="mom-content-locale"
    role="group"
    :aria-label="$t('general.language')"
  >
    <span class="mom-content-locale__label">{{ $t('general.language') }}</span>
    <b-button-group>
      <b-button
        v-for="lang in langs"
        :key="lang.key"
        :variant="lang.key === currentLanguage ? 'primary' : 'outline-primary'"
        :pressed="lang.key === currentLanguage"
        @click="$emit('change-language', lang.key)"
      >
        {{ lang.value }}
      </b-button>
    </b-button-group>
  </div>
</template>

<script>
import {
  BButtonGroup, BButton,
} from 'bootstrap-vue'

export default {
  name: 'ChangeLanguageHeaderTable',
  components: {
    BButton,
    BButtonGroup,
  },
  props: {
    currentLanguage: {
      type: String,
      default: 'fa',
    },
  },
  data() {
    return {
      langs: [
        { key: 'fa', value: 'فارسی' },
        { key: 'ar', value: 'عربی' },
        { key: 'en', value: 'انگلیسی' },
      ],
    }
  },
}
</script>

<style scoped>
.mom-content-locale { display: flex; flex-wrap: wrap; align-items: center; gap: var(--mom-space-3); margin-bottom: var(--mom-space-4); }
.mom-content-locale__label { font-weight: 700; color: var(--mom-color-text-muted); }
.mom-content-locale .btn { min-height: var(--mom-control-height); min-width: 88px; }
</style>
